import { render, staticRenderFns } from "./ProductOrderInvoice.vue?vue&type=template&id=74ffc45b&scoped=true"
import script from "./ProductOrderInvoice.vue?vue&type=script&lang=js"
export * from "./ProductOrderInvoice.vue?vue&type=script&lang=js"
import style0 from "./ProductOrderInvoice.vue?vue&type=style&index=0&id=74ffc45b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffc45b",
  null
  
)

export default component.exports